import { render, staticRenderFns } from "./IconVideo.vue?vue&type=template&id=ebec733c&"
import script from "./IconVideo.vue?vue&type=script&lang=js&"
export * from "./IconVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports